import { IIconProps } from '~/types';

const EurFlag = (props: IIconProps) => (
  <svg
    width={28}
    height={20}
    viewBox="0 0 28 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={28} height={20} rx={2} fill="#fff" />
    <mask
      id="a"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={28}
      height={20}
    >
      <rect width={28} height={20} rx={2} fill="#fff" />
    </mask>
    <g mask="url(#a)">
      <path fill="#043CAE" d="M0 0h28v20H0z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.057 4.276 14 4l.943.276-.276-.943.276-.942-.943.276-.943-.276.276.942zm0 13.334.943-.277.943.277-.276-.943.276-.943L14 16l-.943-.276.276.943zm7.61-6.943-.943.276L20 10l-.276-.943.943.276.943-.276-.277.943.277.943zm-14.276.276.942-.276.943.276L8 10l.276-.943-.943.276-.942-.276.276.943zm13.383-3.61-.943.277.276-.943-.276-.943.943.276.942-.276-.276.943.276.943zm-12.49 6.943L8.227 14l.942.276-.276-.943.276-.942-.942.276-.943-.276.276.942zm10.05-9.383-.943.276.276-.942-.276-.943.942.276.943-.276-.276.943.276.942zm-7.61 11.823.943-.276.943.276-.277-.942.277-.943-.943.276-.943-.276.276.943zM19.774 14l-.943.276.276-.943-.276-.942.943.276.942-.276-.276.942.276.943zM7.284 7.61l.943-.277.942.277-.276-.943.276-.943L8.227 6l-.943-.276.276.943zm10.05 8.83-.943.276.276-.942-.276-.943.942.276.943-.276-.276.943.276.942zM9.723 5.17l.943-.277.943.276-.277-.942.277-.943-.943.276-.943-.276.276.943z"
        fill="#FFD429"
      />
    </g>
  </svg>
);

export default EurFlag;
